module.exports = __webpack_public_path__ + "static/images/dumbbell-dark.89f31ff971944def3d2e3b5c531c998e.svg";